import { survey } from './survey'
import { assets } from './assets'
import { mapStyle } from './map'
import { serviceChangeFields } from '../shared/search'
import FirstNationIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_First Nations health.png'
import OrderPersonIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Older Persons.png'
import AlcoholnDrugIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Alcohol and Other Drugs.png'

import ChronicIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Chronic Conditions.png'

import MentalHealthIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Mental Health.png'
import PopulationHealthIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Population Health.png'
import WorkforceIcon from '../nqphn/assets/images/NQPHN-commissioned-services-map-icons_Workforce.png'

import * as React from 'react'

const config = {
  id: 'default',
  // fonts: {
  //   google: {
  //     families: ['Mulish:300,400,500,700,800,900'],
  //   },
  // },
  options: {
    title: 'NQPHN',
    categoryMode: 'single',
    // combineMode: 'commissioned-services',
    combineMode: 'filters',
    informationCategories: false,
    defaultCategoryTitle: 'Healthcare Services',
    defaultCategorySuffix: 'Services',
  },

  analytics: {
    app: 'nqphn',
    plugins: [
      {
        provider: 'google-analytics',
        // trackingId: 'UA-188798033-1', // AMS Test
        trackingId: '396919186',
        // customScriptSrc: 'https://www.google-analytics.com/analytics_debug.js',
        siteSpeedSampleRate: 100,
      },
      // {
      //   provider: 'cie-elastic',
      //   index: 'prod-ams-amh-analytics',
      //   // debug: true,
      // },
    ],
    // facebook: {
    //   tagId: '482689853334650',
    // },
    // googleSiteVerification: {
    //   tagId: '4ej5FtOzV-vTBi9njysRwwxeoE0kXoVwF5C2d5Z5_8w',
    // },
    googleAnalytics: {
      containerId: 'GTM-PGKKP3D6',
    },
  },

  meta: {
    templates: {
      title: '{{ tenant.options.title }}',
      description: '{{ tenant.options.title }}',
    },
  },

  routes: [
    {
      path: '/',
      exact: true,
      component: 'Search',
    },
    {
      path: '/support',
      component: 'Support',
      container: 'ContentPage',
      props: {
        contentId: 'support',
      },
      meta: {
        templates: {
          title: '{{ tenant.options.title }} - Site Support',
        },
      },
    },
    {
      path: '/location/:lat/:lng',
      component: 'LocationRedirect',
      props: {
        redirectTo: '/',
      },
    },
    {
      path: '/404',
      exact: true,
      component: 'NotFound',
      container: 'ContentPage',
      containerProps: {
        backButton: false,
      },
      meta: {
        templates: {
          title: '{{ tenant.options.title }} - 404 Not Found',
        },
      },
    },
    {
      path: '*',
      component: 'Redirect',
      props: {
        to: '/404',
      },
    },
  ],

  ui: {
    appBar: {
      elevation: 0,
      groups: [
        {
          align: 'fill',
          items: [
            {
              component: 'MenuButton',
              props: {
                sx: { px: 2 },
              },
            },
            {
              component: 'AppBarTitle',
              props: {
                disableTextTitle: true,
                href: 'https://www.nqphn.com.au/',
              },
            },
            {
              component: 'PortalOutlet',
              props: {
                sx: {
                  width: { lg: 800 },
                  flexGrow: { md: 1, lg: 0 },
                  display: { xs: 'none', lg: 'flex' },
                },
              },
            },
          ],
        },
      ],
    },

    menus: {
      navigation: {
        items: [
          {
            id: 'home',
            label: 'Home',
            icon: 'fas fa-home-alt',
            route: '/',
          },
          {
            id: 'support',
            label: 'Site Support',
            icon: 'fas fa-user-headset',
            route: '/support',
          },
          {
            id: 'reset',
            label: 'Clear Settings & Restart',
            icon: 'fas fa-undo',
            function: 'reset',
          },
        ],
      },
    },

    search: {
      tabs: [
        {
          id: 'services',
          title: 'Services',
          icon: 'fas fa-building',
          component: 'SearchResults',
          map: true,
          options: {
            search: 'services',
          },
        },
        {
          id: 'favourites',
          title: 'Favourites',
          icon: 'fas fa-star',
          component: 'SearchResults',
          map: true,
          options: {
            search: 'favourites',
          },
        },
      ],

      desktop: {
        paramsDrawer: {
          breakpoint: 'lg',
        },
        disableParams: true,
      },

      map: {
        locationZoom: 6,
        selectionZoom: 17,
        style: mapStyle,
        locationBoundary: {
          show: true,
          pathOptions: {
            stroke: true,
            color: '#329ec5',
            weight: 1.5,
            opacity: 0.6,
            fill: true,
            fillColor: '#329ec5',
            fillOpacity: 0.2,
          },
        },
        defaultView: {
          center: { lat: -23.698, lng: 133.8807 },
          zoom: 4,
        },
        zoomLevels: {
          geography: {
            2288: 4, // nq
            91: 4, // Cairns and Hinterland
            // 90: 8, // Central Queensland
            // 88: 7, // Central West
            // 79: 7, // Darling Downs
            // 80: 10, // Gold Coast
            81: 4, // Mackay
            // 92: 10, // Metro North
            // 82: 9, // Metro South
            // 89: 7, // North West
            // 83: 7, // South West
            // 84: 9, // Sunshine Coast
            93: 4, // Torres and Cape
            85: 4, // Townsville
            // 86: 9, // West Moreton
            // 87: 8, // Wide Bay
          },
        },
      },

      parameters: {
        query: {
          id: 'query',
          type: 'query',
          label: 'Search',
          icon: 'fa-solid fa-magnifying-glass',
        },
        location: {
          id: 'location',
          type: 'location',
          label: 'Location',
          icon: 'fas fa-map-marker-question',
        },
        geographySelect: {
          id: 'location',
          type: 'geographySelect',
          label: 'Region',
          icon: 'fas fa-map-marker-question',
          queryKey: 'geographySelect',
          sources: [
            {
              type: 'geography',
              id: '2288',
              label: 'All Regions',
              default: true,
            },
            { type: 'dataset', id: 'NQPHN' },
          ],
        },
        categories: {
          id: 'categories',
          type: 'categoryButtons',
          label: 'Categories',
          icon: 'far fa-stream',
        },
        categorySelect: {
          id: 'categories',
          type: 'categorySelect',
          label: 'Categories',
          icon: 'far fa-stream',
        },
      },

      parameterGroups: {
        desktop: {
          controls: [
            { param: 'query' },
            { param: 'geographySelect' },
            { param: 'categorySelect' },
          ],
        },
        appBar: {
          disableLabels: true,
          containerProps: {
            columns: 3,
            spacing: 1,
            sx: { px: 3, py: 0, width: '100%' },
          },
          controls: [
            { param: 'query', props: { showSearchIcon: true } },
            { param: 'geographySelect' },
            { param: 'categorySelect' },
          ],
        },
        mobileSearch: {
          controls: [
            { param: 'query' },
            { param: 'geographySelect' },
            { param: 'categorySelect' },
          ],
        },
      },

      resultsList: {
        default: {
          sections: [
            {
              type: 'initBlock',
              items: [{ component: 'Welcome' }],
            },
            {
              type: 'resultsBlock',
              items: [{ component: 'Results' }],
            },
            {
              type: 'statusBlock',
              items: [{ component: 'Status' }, { component: 'SiteSupport' }],
            },
          ],
        },
        favourites: {
          sections: [
            {
              type: 'initBlock',
              items: [{ component: 'Welcome' }],
            },
            {
              type: 'resultsBlock',
              items: [{ component: 'Results' }],
            },
            {
              type: 'statusBlock',
              items: [
                { component: 'FavouritesStatus' },
                { component: 'SiteSupport' },
              ],
            },
          ],
        },
      },

      resultItem: {
        service: {
          components: [
            {
              component: 'BadgeList',
              hideVariant: 'map',

              options: {
                icon: 'default',
                styles: {
                  inactive: {
                    backgroundColor: '#bbb',
                  },
                },
              },
            },
            {
              component: 'Title',
              showCategory: false,
              options: {
                showOrganisationName: true,
              },
            },
            {
              component: 'Details',
              fields: [
                { key: 'operatingDays', icon: 'far fa-clock' },
                {
                  key: 'address',
                  icon: 'fas fa-map-marker-alt',
                },
                { key: 'phone', icon: 'fas fa-phone' },
              ],
            },
            {
              component: 'AddressWithheld',
              hideVariant: 'list',
            },
            {
              component: 'Description',
              hideVariant: 'map',
            },
            {
              component: 'ServiceRegionNames',
              hideVariant: 'map',
            },
            {
              component: 'Spacer',
              hideVariant: 'map',
            },
            {
              component: 'ServiceCohortTags',
              hideVariant: 'map',
            },
            {
              component: 'ServiceChanges',
              fields: serviceChangeFields,
              hideVariant: 'map',
            },
            {
              component: 'HealthEngine',
              hideVariant: 'map',
            },
          ],
        },
      },
    },
  },

  /*
  footer: {
    backgroundColor: '#ddd',
    columns: ['cie'],
  },
  */

  categories: [
    {
      id: 'Aboriginal-Health',
      title: 'First Nations Health',
      searchOptions: {
        filter: {
          tags: [1666],
        },
      },
      badge: {
        tagId: 1666,
        backgroundColor: '#F7921E',
        extraIcon: FirstNationIcon,
      },
    },
    {
      id: 'Aged-Care',
      title: 'Older Persons and Palliative Health',
      searchOptions: {
        filter: {
          tags: [1667],
        },
      },
      badge: {
        tagId: 1667,
        backgroundColor: '#003E6A',
        extraIcon: OrderPersonIcon,
      },
    },
    {
      id: 'Alcohol&Other Drug',
      title: 'Alcohol and Other Drugs',
      searchOptions: {
        filter: {
          tags: [1668],
        },
      },
      badge: {
        tagId: 1668,
        backgroundColor: '#00A2C5',
        extraIcon: AlcoholnDrugIcon,
      },
    },
    {
      id: 'Chronic-Conditions',
      title: 'Chronic Conditions',
      searchOptions: {
        filter: {
          tags: [1669],
        },
      },
      badge: {
        tagId: 1669,
        backgroundColor: '#003E6A',
        extraIcon: ChronicIcon,
      },
    },
    {
      id: 'Mental-Health',
      title: 'Mental Health',
      searchOptions: {
        filter: {
          tags: [1670],
        },
      },
      badge: {
        tagId: 1670,
        backgroundColor: '#00A2C5',
        extraIcon: MentalHealthIcon,
      },
    },
    {
      id: 'Population-Health',
      title: 'Population Health',
      searchOptions: {
        filter: {
          tags: [1677],
        },
      },
      badge: {
        tagId: 1677,
        backgroundColor: '#003E6A',
        extraIcon: PopulationHealthIcon,
      },
    },
    {
      id: 'Workforce',
      title: 'Workforce',
      searchOptions: {
        filter: {
          tags: [1678],
        },
      },
      badge: {
        tagId: 1678,
        backgroundColor: '#62BB46',
        extraIcon: WorkforceIcon,
      },
    },
  ],

  search: {
    location: {
      showLocationDialog: false,
      initLocation: 'default',
      defaultLocation: {
        type: 'geography',
        id: 2288,
        default: true,
        label: 'All Regions',
        dataset: 'AUSSTATES',
        area: 510172400166.882,
        lat: -18.3595057568941,
        lng: 144.677549094795,
        kmlUrl:
          'https://devdirectorycdn.blob.core.windows.net/kml/phn/northern_queensland.kml',
      },
    },
    queries: [
      {
        id: 'services',
        builder: 'directory',
        parameters: [
          { param: 'page' },
          { param: 'sort', sortField: 'Name', sortDirection: 'ASC' },
          { param: 'query' },
          // { param: 'commissionedServices' },
          // { param: 'locationRegion' },
          { param: 'serviceRegions' },
          { param: 'defaultGeoId' },
          { param: 'isIncludeOutsideRegion' },
          { param: 'filters' },
        ],
      },
    ],
    searches: {
      services: {
        id: 'services',
        type: 'directory',
        pageSize: 1000,
        showSiteSupport: true,
        defaultFilter: { terms: { serviceTags: [-1] } },
      },
      favourites: {
        id: 'favourites',
        type: 'favourites',
      },
    },
  },

  assets,
  survey,
}

export default config
